












































































import DateField from '@/components/FormBuilder/fields/DateField.vue';
import AccountingSheetController from '@/controllers/AccountingSheet';
import { UpdateAccountingSheetData } from '@/controllers/types';
import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';
import { Validations } from 'vuelidate-property-decorators';
import { validationMixin } from 'vuelidate';
import { AccountingSheetInterface } from '@/types/AccountingSheet';

@Component({
  components: {
    DateField,
  },
})
export default class SapData extends Mixins(validationMixin) {
  @Prop()
  readonly accountingSheet!: AccountingSheetInterface;

  isSavingSapData = false;

  showCopyText = false;

  sapData = {
    // дата счета на документе от поставщика, бух проверяет, но не заполняет : автоматом или контролинг
    doc_date: '',
    // дата проведения документа в рамках открытого периода - должен вносить бух, автоматизировать не нужно
    post_date: '',
    // № счет-фактуры дата счета на документе от поставщика, бух проверяет, но не заполняет : автоматом или контролинг
    invoice_number: '',
    // № счета дата счета на документе от поставщика, бух проверяет, но не заполняет : автоматом или контролинг
    account_number: '',
    // Итого НДС
    total_tax: 0,
    for_copying: '',
  }

  labelSapData = {
    doc_date: 'Дата счета',
    post_date: 'Дата проведения документа',
    invoice_number: '№ Счет-фактуры или УПД или Акта',
    account_number: '№ счета',
    total_tax: 'Итого НДС',
  }

  beforeMount() {
    this.fillSapData(this.accountingSheet);
  }

  @Validations()
  validations() {
    return {
      sapData: {
        doc_date: {
          required,
        },
        post_date: {
          required,
        },
        invoice_number: {
          required,
        },
        account_number: {
          required,
        },
      },
    };
  }

  get isControllingApprovalStatus(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === 'controlling_approval';
  }

  get isAwaitSigningStatus(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === 'diadoc_signing_await';
  }

  get isAccountingApprovalStatus(): boolean {
    return this.accountingSheet !== null && this.accountingSheet.status === 'accounting_approval';
  }

  get isStatusWithAction(): boolean {
    return this.isControllingApprovalStatus || this.isAwaitSigningStatus || this.isAccountingApprovalStatus;
  }

  onDateChange(value: string, key: string): void {
    Object.assign(this.sapData, { [key]: value });
  }

  copyText() {
    const element = this.$refs.for_copying;
    (element as any).select();
    document.execCommand('copy');
    this.showCopyText = true;
    setTimeout(() => {
      this.showCopyText = false;
    }, 3000);
  }

  fillSapData(accountingSheet: AccountingSheetInterface): void {
    if (accountingSheet) {
      this.sapData.doc_date = accountingSheet.accountDate || '';
      this.sapData.post_date = accountingSheet.documentDate || '';
      this.sapData.invoice_number = accountingSheet.invoiceNumber || '';
      this.sapData.account_number = accountingSheet.accountNumber || '';
      this.sapData.total_tax = accountingSheet.taxAmount || 0;

      const formattedNumber = accountingSheet.number.replace(/^\D+/g, '');
      let formattedFinishDate = '';
      const finishDate = accountingSheet.finishDate ? new Date(accountingSheet.finishDate) : null;
      if (finishDate !== null) {
        finishDate.setDate(finishDate.getDate() + accountingSheet.contractPaymentPeriod2);
        formattedFinishDate = finishDate.toLocaleDateString();
      }
      const formattedTotal = accountingSheet.total.toFixed(2);
      this.sapData.for_copying = `${formattedNumber}_${accountingSheet.fmLegalCode}_${formattedFinishDate}_${formattedTotal}`;
    }
  }

  getValidationErrors(validations: any): Array<string> {
    const errors: Array<string> = [];
    if (!validations || validations.$error === false || validations.$invalid === false) {
      return errors;
    }
    if (validations.required === false) {
      errors.push('Обязательное поле');
    }
    return errors;
  }

  getPreparedData(): UpdateAccountingSheetData {
    let data: UpdateAccountingSheetData = {
      documentDate: String(this.sapData.post_date),
      accountDate: String(this.sapData.doc_date),
      invoiceNumber: String(this.sapData.invoice_number),
      accountNumber: String(this.sapData.account_number),
      sheetId: this.accountingSheet.id,
    };
    if (this.sapData.total_tax) {
      data = { ...data, taxAmount: this.sapData.total_tax };
    }
    return data;
  }

  async onSubmit(silence = false): Promise<boolean> {
    let answer = false;
    if (!this.isStatusWithAction) {
      this.$bus.$emit('notification', 'Статус листа учета не позволяет сохранить данные SAP', 'warning');
      return answer;
    }
    try {
      this.$v.$touch();
      if (this.$v.$invalid && !this.isControllingApprovalStatus) return answer;
      this.isSavingSapData = true;
      const response = await AccountingSheetController.update(this.getPreparedData());
      const [error, result] = response.result;
      if (result.result) {
        console.log('Result after saving SAP data - ', result);
        if (!silence) this.$bus.$emit('notification', 'Данные SAP успешно сохранены', 'success');
        answer = true;
      }
      if (error) {
        this.$bus.$emit('notification', `Возникла ошибка при сохранении данных SAP, попробуйте позже - ${error}`, 'error');
        console.error(error);
      }
    } catch (error) {
      this.$bus.$emit('notification', `Возникла ошибка при сохранении данных SAP, попробуйте позже - ${error}`, 'error');
      console.error(error);
    } finally {
      this.isSavingSapData = false;
    }
    return answer;
  }
}
